export const queryParamtoValueMap = {
  node: 'javascript'
};

export const valueToQueryParamMap = {
  javascript: 'node'
};
